<template>
  <div class="register-body">
    <h4>{{$t('scope.text_315')}}</h4>
    <p class="title-desc">{{$t('scope.text_316')}}</p>
    <a-form :form="form.fc" @submit="handleSubmit">
      <a-form-item>
        <a-input class="material-input" v-decorator="decorator.user_name" :placeholder="$t('scope.text_317')">
          <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, .25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input class="material-input" v-decorator="decorator.enterprise_name" :placeholder="$t('scope.text_318')">
          <a-icon slot="prefix" type="home" style="color: rgba(0, 0, 0, .25)" />
        </a-input>
      </a-form-item>
      <!-- <a-form-item>
        <a-input class="material-input" v-decorator="decorator.email" :placeholder="$t('scope.text_319')">
          <a-icon slot="prefix" type="mail" style="color: rgba(0, 0, 0, .25)" />
        </a-input>
      </a-form-item> -->
      <a-form-item>
        <a-input-password class="material-input" v-decorator="decorator.password" type="password" autocomplete="new-password" :placeholder="$t('validator.password')">
          <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, .25)" />
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-input-password class="material-input" v-decorator="decorator.com_password" type="password" autocomplete="new-password" :placeholder="$t('scope.text_321')">
          <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, .25)" />
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-input class="material-input" v-decorator="decorator.contact" :placeholder="$t('op_112')">
          <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, .25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input class="material-input" v-decorator="decorator.mobile" :placeholder="$t('scope.text_323')" addonBefore="+86">
          <a-icon slot="prefix" type="phone" style="color: rgba(0, 0, 0, .25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input-group>
          <a-row :gutter="8">
            <a-col :span="18">
              <a-input v-decorator="decorator.sms_code" :placeholder="$t('scope.text_324')" />
            </a-col>
            <a-col :span="6">
              <a-button :disabled="enableSendSmsCode" @click="getWebSmsCode" style="width: 100%">{{ enableSendSmsCode ? $t('scope.text_325', [count]) : $t('scope.text_326') }}</a-button>
            </a-col>
          </a-row>
        </a-input-group>
      </a-form-item>
      <a-form-item>
        <a-textarea class="material-input" v-decorator="decorator.description" :placeholder="$t('scope.text_327')">
          <a-icon slot="prefix" type="container" style="color: rgba(0, 0, 0, .25)" />
        </a-textarea>
      </a-form-item>
      <a-form-item>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-checkbox v-decorator="decorator.isAgreement" @change="handleAgreementchange">
              <router-link target="_blank" :to="{ name: 'Agreement'}">{{$t('scope.user_agreement')}}</router-link>
            </a-checkbox>
          </a-col>
          <a-col :span="12">
            <p style="text-align: right"><router-link :to="{ name: 'Login'}">{{$t('scope.text_329')}}</router-link></p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" :loading="loading" block :disabled="disabled">{{$t('scope.text_330')}}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EMAIL_PROVIDER } from './constants/emailProviderdomain'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ChannelPartnerRegister',
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      enableSendSmsCode: false,
      startCountDown: false,
      count: 60,
      timer: null,
      disabled: true,
      form: {
        fc: this.$form.createForm(this),
      },
      decorator: {
        user_name: [
          'user_name',
          {
            validateFirst: true,
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_331') },
              { validator: this.checkSpecialSymbol },
            ],
          },
        ],
        enterprise_name: [
          'enterprise_name',
          {
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_332') },
            ],
          },
        ],
        // email: [
        //   'email',
        //   {
        //     validateFirst: true,
        //     validateTrigger: ['blur'],
        //     rules: [
        //       { required: true, message: '请输入企业邮箱' },
        //       { validator: this.$validate('email') },
        //       { validator: this.checkCompanyEmail },
        //     ],
        //   },
        // ],
        password: [
          'password',
          {
            validateFirst: true,
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_333') },
              { validator: this.$validate('password') },
            ],
          },
        ],
        com_password: [
          'com_password',
          {
            validateFirst: true,
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_334') },
              { validator: this.checkComPassword },
            ],
          },
        ],
        contact: [
          'contact',
          {
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('op_113') },
            ],
          },
        ],
        mobile: [
          'mobile',
          {
            validateFirst: true,
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_336') },
              { validator: this.$validate('phone') },
            ],
          },
        ],
        sms_code: [
          'sms_code',
          {
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_337') },
            ],
          },
        ],
        description: [
          'description',
          {
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_338') },
            ],
          },
        ],
        isAgreement: [
          'isAgreement',
          {
            initialValue: false,
          },
        ],
      },
      isAgreement: false,
    }
  },
  computed: {
    ...mapGetters(['logo']),
  },
  watch: {
    startCountDown (val) {
      if (val) {
        this.clearTimer()
        this.timer = setInterval(() => {
          if (this.count !== 0) {
            this.count--
          } else {
            this.enableSendSmsCode = false
            this.startCountDown = false
          }
        }, 1000)
      }
    },
  },
  destroyed () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    handleAgreementchange (e) {
      this.disabled = !e.target.checked
    },
    checkSpecialSymbol (rule, value, callback) {
      const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/
      if (reg.test(value)) {
        callback(new Error(this.$t('scope.text_339')))
      }
      if (value.indexOf('@') >= 0) {
        callback(new Error(this.$t('scope.text_340')))
      }
      if (value.length < 4) {
        callback(new Error(this.$t('scope.text_341')))
      }
      callback()
    },
    checkComPassword (rule, value, callback) {
      const password = this.form.fc.getFieldValue('password')
      if (password !== value) {
        callback(new Error(this.$t('scope.text_342')))
      }
      callback()
    },
    getWebSmsCode () {
      const mobile = this.form.fc.getFieldValue('mobile')
      if (!mobile) {
        this.$message.warn(this.$t('scope.text_343'))
        return
      }
      this.createDialog('WebSmsCodeDialog', {
        mobile,
        success: () => {
          this.enableSendSmsCode = true
          this.startCountDown = true
        },
      })
    },
    checkCompanyEmail (rule, value, callback) {
      const domain = value.split('@')[1]
      if (EMAIL_PROVIDER.includes(domain)) {
        callback(new Error(this.$t('scope.text_344')))
      }
      callback()
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.fc.validateFields(async (err, values) => {
        if (err) return
        this.loading = true
        try {
          const data = {
            method: 'mobile',
            user_name: values.user_name,
            // name: values.email.split('@')[1],
            password: values.password,
            sms_code: values.sms_code,
            is_agent: true,
            enterprise_name: values.enterprise_name,
            contact: values.contact,
            memo: values.description,
            mobile: values.mobile,
          }
          await this.$http.post('/v2/register/customers', data)
          this.$router.push({
            path: 'registerresult',
            query: {
              ...this.$route.query,
              user_name: data.user_name,
              // name: data.name,
            },
          })
        } catch {
          this.loading = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.logo {
  text-align: right;
  img {
    height: 40px;
  }
}
h4 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.title-desc {
  color: #9b9ea0;
  margin-bottom: 20px;
}
.register-body {
  width: 570px;
  height: 820px;
  position: relative;
  background-color: #fff;
  padding: 40px;
  ::v-deep {
    .ant-input-group-addon {
      border: 0;
    }
  }
}
</style>
